import IconButton from '@/components/ui/custom/buttons/IconButton';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { TrashIcon } from '@heroicons/react/24/outline';
import { QuizAnswerContainer } from '../../preview/quiz/Answer';
import { QuizAnswersType } from '@/models/_deprecated/ActivityElement';
import { QuizAnswer } from '@/data/services/activityElement/quizServices';

type Props = {
  value: QuizAnswer;
  onChange: (value: QuizAnswer) => void;
  onRemove?(): void;
  index: number;
};

function QuizAnswerInput({ value, onChange, onRemove, index }: Props) {
  function handleChange({ isCorrect, answer }: Partial<QuizAnswer>) {
    const changes: Partial<QuizAnswer> = {};
    if (isCorrect !== undefined) {
      changes.isCorrect = isCorrect;
    }
    if (answer !== undefined) {
      changes.answer = answer;
    }
    onChange({ ...value, ...changes });
  }

  return (
    <div className="flex gap-2.5 items-center w-full">
      <QuizAnswerContainer
        className="border-secondary-content border w-full"
        answerType={QuizAnswersType.TEXT}
        selected={value.isCorrect}
        index={index}
      >
        <input
          type="text"
          data-testid="answerInput"
          className="bg-transparent w-full font-rubik font-400 text-16"
          value={value.answer.toString()}
          onChange={e => handleChange({ answer: e.target.value })}
        />
      </QuizAnswerContainer>
      <input
        type="checkbox"
        data-testid="isCorrectInput"
        checked={!!value.isCorrect}
        className="toggle toggle-primary mx-2"
        onChange={e =>
          handleChange({
            isCorrect: !!e.target.checked,
          })
        }
      />
      <ConditionalRenderer condition={!!onRemove}>
        <IconButton
          icon={<TrashIcon className="w-4 h-4" />}
          testId="removeAnswerButton"
          className="text-error"
          onClick={onRemove}
        />
      </ConditionalRenderer>
    </div>
  );
}

export default QuizAnswerInput;
